import { ClaimReservationResponse } from '@interaction-gaming/player-data-service-browser-client'

import DetailsBackground from '@Assets/confirmation-background.png'
import { ComponentUtils } from '@Components/utils'
import { Button } from '@Components/button/button'
import { Header } from '@Components/header/header'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@AppState/redux-store'
import { hostConfigByName } from '../../config/utils'
import { PlayerDataServiceAPI } from '@API/data-services/player-data-service'
import { ClaimReservationActions } from '@AppState/claim-reservation'
import { LoadingIndicator } from '@Components/loading-indicator/loading-indicator'
import { useEffect } from 'react'

const CLASS_NAME = 'status-screen'

import './status-screen.scss'

export type DeleteReservationScreenProps = {
  reservation: ClaimReservationResponse
}
export const DeleteReservationScreen = ({ reservation }: DeleteReservationScreenProps) => {
  const dateInfo = reservation.timeslot.display.dateComponents

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const hostName = useSelector((state: RootState) => state.appConfig.config?.hostName)

  const { mutate: deleteReservation, isPending } = useMutation({
    mutationFn: async () => {
      return await PlayerDataServiceAPI.deleteClaimReservation(reservation.id)
    },
    onSuccess: () => {},
  })

  useEffect(() => {
    deleteReservation()
  }, [deleteReservation])

  if (!hostName) {
    throw new Error('Unable to determine host name')
  }
  const hostConfig = hostConfigByName[hostName]

  if (isPending) {
    return (
      <>
        <Header title="Delete Appointment" />
        <LoadingIndicator active={isPending} />
      </>
    )
  }

  return (
    <>
      <Header title={'Appointment Deleted'} />
      <section>
        <div
          style={{ backgroundImage: `url(${DetailsBackground}` }}
          className={`${CLASS_NAME}__details`}>
          <section className={`${CLASS_NAME}__details-text`}>
            <p>Appointment Deleted</p>
            <h1>{`${dateInfo.dayOfWeek} ${dateInfo.month} ${dateInfo.dayOfMonth}${ComponentUtils.suffixForDateNumber(Number(dateInfo.dayOfMonth))} @ ${reservation.timeslot.display.localTime}`}</h1>
            <p>at the</p>
            <h3>
              {ComponentUtils.claimCenterDisplayName(
                reservation.claimCenter.name,
                hostConfig.claimCenterNameSuffix,
              )}
            </h3>

            <section className={`${CLASS_NAME}__details-address`}>
              <p>{reservation.claimCenter.address1}</p>
              <p>{reservation.claimCenter.address2}</p>
              <p>
                {reservation.claimCenter.city}, {reservation.claimCenter.region}{' '}
                {reservation.claimCenter.postalCode}
              </p>
            </section>
          </section>
        </div>
        <section className={`${CLASS_NAME}__cta-section`}>
          <Button
            onClick={() => {
              dispatch(ClaimReservationActions.clearSavedReservation())
              navigate(`/create${location.search}`)
            }}>
            Create new appointment
          </Button>
        </section>
      </section>
    </>
  )
}
